import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const FeedbackStatus = ({ value }: any) => {
  const [Color, setColor] = useState<string>("");
  const { t } = useTranslation();

  useEffect(() => {
    switch (value) {
      case "Processing":
        setColor("#50B8E7");
        break;
      case "Pending Backoffice":
      case "Pending Sales":
        setColor("#EFBE12");
        break;
      case "Rejected File":
        setColor("#DC4D4D");
        break;
      case "Done":
        setColor("#2DE28B");
        break;
    }
  }, [value, t]);

  return (
    <span
      className={`text-[12px] bg-opacity-10 font-inter-light px-[8px] py-[3px] rounded-[4px] whitespace-nowrap`}
      style={{ background: Color + "1A", color: Color }}
    >
      {value}
    </span>
  );
};



export const lastTenPendings = (
  { setModalData }: {
    setModalData?: (data: { modalType: string; data: { id: number | undefined } }) => void
  }) => {


  return [
    {
      Header: "Created At",
      accessor: (row: any) => new Date(row?.created_at),
      Cell: ({ row }: any) => {

        const date = row.original.created_at;
        return (
          <span
            className="cursor-pointer"
            onClick={() => setModalData && setModalData({ modalType: "pendings", data: { id: row.original.id } })}
          >
            {date ? new Date(date).toLocaleDateString("de") : "Not available"}
          </span>
        );
      },
      id: 1,
      isChecked: true,
    },
    {
      Header: "Deadline",
      accessor: (row: any) => row?.deadline ? new Date(row?.deadline) : 'deadline',
      Cell: ({ row }: any) => {

        const deadline = row.original.deadline;
        return (
          <span
            className="cursor-pointer"
            onClick={() => setModalData && setModalData({ modalType: "pendings", data: { id: row.original.id } })}

          >
            {deadline ? new Date(deadline).toLocaleDateString("de") : "Not available"}
          </span>
        );
      },
      id: 2,
      isChecked: true,
    },
    {
      Header: "Category",
      accessor: "category",
      Cell: ({ row }: any) => {

        return (
          <span
            className="cursor-pointer"
            onClick={() => setModalData && setModalData({ modalType: "pendings", data: { id: row.original.id } })}
          >
            {row.original.category || "Not available"}
          </span>
        );
      },
      id: 3,
      isChecked: true,
    },
    {
      Header: "Title",
      accessor: "title",
      Cell: ({ row }: any) => {

        return (
          <span
            className="cursor-pointer"
            onClick={() => setModalData && setModalData({ modalType: "pendings", data: { id: row.original.id } })}
          >
            {row.original.title || "Not available"}
          </span>
        );
      },
      id: 4,
      isChecked: true,
    },
    {
      Header: "Worker",
      accessor: "worker",
      Cell: ({ row }: any) => {

        return (
          <span
            className="cursor-pointer"
            onClick={() => setModalData && setModalData({ modalType: "pendings", data: { id: row.original.id } })}
          >
            {row.original.to_user || "Not available"}
          </span>
        );
      },
      id: 5,
      isChecked: true,
    },
    {
      id: 6,
      Header: "Status",
      accessor: (row: any) => row?.status || "Not available",
      Cell: ({ row, value }: any) => {

        return (
          <div
            className="cursor-pointer"
            onClick={() => setModalData && setModalData({ modalType: "pendings", data: { id: row.original.id } })}
          >
            <FeedbackStatus value={value} />
          </div>
        );
      },
      isChecked: true,
    },
  ];
}
